import { useState } from "react";
import { toast } from "sonner";
import { Empty, PortalHeading } from "./PortalLayout";
import { PaynowDialog } from "@/components/shared/PaynowDialog";
import { StatusPill } from "@/components/shared/QuoteTypeBadge";
import { useFetch } from "@/hooks/useFetch";
import { api, fmtDate, money } from "@/lib/api";

export default function Billing() {
  const { data, reload } = useFetch("/portal/invoices");
  const [paying, setPaying] = useState(null);
  const pay = async (method) => {
    const r = await api.post("/portal/billing/paynow-simulate", { invoice_reference: paying.reference, amount: paying.balance, method });
    toast.success(`Payment recorded (simulated) — ${r.data.tx_ref}`);
    reload();
  };
  return (
    <div data-testid="portal-billing">
      <PortalHeading title="Invoices & Payments" sub="Payments run through a simulated Paynow checkout — no real money moves yet." />
      {data && !data.invoices.length && <Empty testId="invoices-empty">No invoices yet.</Empty>}
      <div className="space-y-4">
        {data?.invoices.map((inv) => (
          <article key={inv.reference} className="rounded-2xl bg-white p-6" data-testid={`invoice-card-${inv.reference}`}>
            <div className="flex flex-wrap items-start justify-between gap-3">
              <div><p className="text-xs font-bold tracking-widest text-[#F86900]">{inv.reference}</p><p className="text-sm text-[#56585E]">Issued {fmtDate(inv.created_at)} · quote {inv.quote_reference}</p></div>
              <StatusPill status={inv.status} testId={`invoice-status-${inv.reference}`} />
            </div>
            <div className="mt-3 divide-y text-sm">{inv.line_items.map((i, idx) => <div key={idx} className="flex justify-between py-1.5"><span>{i.label}</span><span>{money(i.total)}</span></div>)}</div>
            <div className="mt-3 grid grid-cols-3 gap-3 text-sm">
              <div><p className="text-[#56585E] text-xs">Total</p><p className="font-bold">{money(inv.subtotal)}</p></div>
              <div><p className="text-[#56585E] text-xs">Paid</p><p className="font-bold text-[#027A48]">{money(inv.paid)}</p></div>
              <div><p className="text-[#56585E] text-xs">Balance</p><p className="font-bold" data-testid={`invoice-balance-${inv.reference}`}>{money(inv.balance)}</p></div>
            </div>
            {Number(inv.balance) > 0 && (
              <button onClick={() => setPaying(inv)} data-testid="billing-paynow-pay-button" className="mt-4 rounded-full bg-[#F86900] text-[#0D141A] font-bold px-6 py-2.5 text-sm">Pay {money(inv.balance)} with Paynow</button>
            )}
            {inv.transactions?.length > 0 && (
              <div className="mt-4 text-xs text-[#56585E] space-y-1">{inv.transactions.map((t) => <p key={t.id}>{fmtDate(t.at)} · {t.method} · {money(t.amount)} · {t.tx_ref} {t.simulated && "(simulated)"}</p>)}</div>
            )}
          </article>
        ))}
      </div>
      {paying && <PaynowDialog open={!!paying} onOpenChange={(o) => !o && setPaying(null)} amount={paying.balance} reference={paying.reference} onPay={pay} />}
    </div>
  );
}
